import styled, { keyframes } from "styled-components";
import { Flex } from "@rebass/grid";

import theme from "theme";

export const ProductsLoaderContainer = styled(Flex)`
  justify-content: center;
`

const elipsis1 = keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`

const elipsis2 = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
`

const elipsis3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`

export const ProductsLoader = styled.div`
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  div {
    position: absolute;
    top: 33px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${theme.colors.secondary};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 8px;
    animation: ${elipsis1} 0.6s infinite;
  }
  div:nth-child(2) {
    left: 8px;
    animation: ${elipsis2} 0.6s infinite;
  }
  div:nth-child(3) {
    left: 32px;
    animation: ${elipsis2} 0.6s infinite;
  }
  div:nth-child(4) {
    left: 56px;
    animation: ${elipsis3} 0.6s infinite;
  }
`